<div class="modal-header p-4 " style="background: #fff8e1;">
    <h5 class="modal-title">&nbsp;Add Service - {{reservationId}}</h5>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
</div>
<div class="modal-body p-4">
    <div class="container">
        <form [formGroup]="services_form" novalidate>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="inputEmail4">Contract Name</label>
                    <ng-select formControlName="contractId" (change)="getServicesByContractId($event)">
                        <div *ngFor="let contract of contractList">
                            <ng-option value="{{contract?.CONTRACTID}}">
                                {{contract?.CONTRACTID}}
                            </ng-option>
                        </div>
                    </ng-select>
                </div>
                <div class="form-group col-md-6">
                    <label for="inputEmail4">Service *</label>
                    <ng-select formControlName="service" (change)="onServiceChange($event)">
                        <div *ngFor="let service of serviceList">
                            <ng-option value="{{service?.ContractServicesID}}">
                                {{service?.LongDesc}}
                            </ng-option>
                        </div>
                    </ng-select>
                    <div *ngFor="let validation of validation_messages.service">
                        <div class="error-message"
                            *ngIf="s.service.hasError(validation.type) && ((s.service.dirty  || s.service.touched))">
                            {{validation.message }}
                        </div>
                    </div>
                </div>
                <div class="form-group col-xl-4 col-md-4 col-sm-4">
                    <label for="quantity">Quantity *</label>
                    <input class="form-control" min="1" matInput formControlName="quantity" required id="quantity" type="number"
                        (change)="onServiceAmount(s.quantity)"
                        [ngClass]="{'is-invalid': submitted && s.quantity.errors}">
                    <div *ngFor="let validation of validation_messages.quantity">
                        <div class="error-message"
                            *ngIf="s.quantity.hasError(validation.type) && ((s.quantity.dirty  || s.quantity.touched))">
                            {{validation.message }}
                        </div>
                    </div>
                </div>
                <div class="form-group col-xl-4 col-md-4 col-sm-4" *ngIf="getContractType() === 'MiscService'">
                    <label for="serviceAmount">Unit Charge *</label>
                    <input class="form-control" min="0" type="number" matInput formControlName="amount" required id="serviceAmount"  (change)="onServiceAmount(s.quantity)"
                        [ngClass]="{'is-invalid': submitted && s.amount.errors}">
                    <div *ngFor="let validation of validation_messages.amount">
                        <div class="error-message"
                            *ngIf="s.amount.hasError(validation.type) && ((s.amount.dirty  || s.amount.touched))">
                            {{validation.message }}
                        </div>
                    </div>
                </div>

                <div class="form-group col-xl-4 col-md-4 col-sm-4" *ngIf="getContractType() != 'MiscService'">
                    <label for="serviceAmount">Unit Charge *</label>
                    <input class="form-control" min="0" type="number" matInput readonly [value]="serviceUnitCharge"
                        id="serviceTotalAmount">
                </div>
                <div class="form-group col-xl-4 col-md-4 col-sm-4" >
                    <label for="serviceAmount">Total</label>
                    <input class="form-control" min="0" type="number" matInput readonly [value]="totalServiceAmount"
                        id="serviceTotalAmount">
                </div>
                <div class="form-group col-md-6 col-xl-8  col-sm-12">
                    <label for="serviceNotes">Service Notes</label>
                    <textarea class="form-control" placeholder="Service Notes" id="serviceNotes"
                        formControlName="serviceNotes"></textarea>
                </div>

            </div>
            <div class="row">
                <div class="col-xl-12">
                    <div class="form-group">
                        <button class="btn btn-primary" type="button" id="addServiceBtn" (click)="addService()">Add
                            service</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>